import { Routes } from '@angular/router';

export const appRoutes: Routes = [
  // Auth (público con publicGuard interno)
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  // Dashboard (protegido con authGuard interno)
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./features/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
  },
  // Sandbox (dev)
  {
    path: 'signature-generator',
    loadComponent: () =>
      import('./sandbox/signature-generator/signature-generator.component').then(
        (m) => m.SignatureGeneratorComponent,
      ),
  },
  // Changelog
  {
    path: 'changelog',
    loadComponent: () =>
      import('./features/changelog/pages/changelog.component').then(
        (m) => m.ChangelogComponent,
      ),
  },
  // Landing (público — al final para no interceptar auth/dashboard)
  {
    path: '',
    loadChildren: () =>
      import('./features/landing/landing.routes').then((m) => m.LANDING_ROUTES),
  },
  // Fallback
  { path: '**', redirectTo: '' },
];
